import { FC, ReactNode, SelectHTMLAttributes, useState } from 'react'
import { InputContainer, InputLabel, InputBox, LabelContainer, LabelDescription } from './styles'
import { ValidationError, useErrors } from 'src/context/errors';

interface StandardSelectProps extends SelectHTMLAttributes<HTMLSelectElement> {
  children?: ReactNode;
  label?: string;
  labelSize?: 'small' | 'high';
  labelDescription?: string;
  width?: string;
  isIncorrect?: boolean;
  errorCode?: string;
  errorMessage?: ReactNode;
}

const StandardSelect: FC<StandardSelectProps> = ({
  children,
  label,
  labelSize,
  labelDescription,
  width,
  isIncorrect,
  errorCode = '',
  errorMessage,
  ...rest
}) => {
  const [isFocused, setIsFocused] = useState(false)
  const { hasError, getErrorMessage } = useErrors()

  isIncorrect = hasError(errorCode) || isIncorrect
  errorMessage = getErrorMessage(errorCode) || errorMessage

  return (
    <InputContainer width={width}>
      <LabelContainer>
        <InputLabel labelSize={labelSize ?? 'small'} isIncorrect={isIncorrect}>{label}</InputLabel>
        <LabelDescription labelSize={labelSize ?? 'small'} isIncorrect={isIncorrect}>{labelDescription}</LabelDescription>
      </LabelContainer>
      <InputBox data-error-code={errorCode} isFocused={isFocused} isIncorrect={isIncorrect}>
        <select
          {...rest}
          onFocus={() => setIsFocused(true)}
          onBlur={() => setIsFocused(false)}
        >
          {children}
        </select>
      </InputBox>
      {!!errorMessage ? (
      <small style={{ whiteSpace: 'normal' }}>{errorMessage}</small>
      ) : null}
    </InputContainer>
  )
}

export default StandardSelect